import styled, { css } from 'styled-components'

export const PriceGroupItemUi = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr 1fr 1fr;
  padding: 28px 24px;

  ${p => p.theme.phone} {
    display: flex;
    padding: 15px;
    flex-direction: column;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
    display: flex;
    padding: 15px;
    flex-direction: column;
  `}
`

export const PriceGroupItemTitleUi = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #000033;
  font-weight: bold;
  line-height: 28px;
  font-size: 18px;
  flex-shrink: 0;

  @media only screen and (max-width: 1000px) {
    font-size: 16px;
    margin-bottom: 10px;
  }

  ${p => p.theme.phone} {
    font-size: 18px;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      font-size: 18px;
    `}
`

export const PriceGroupItemPlanUi = styled.div`
  width: 100%;
  display: flex;
  color: #181c39;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  padding: 12px 0;

  @media only screen and (min-width: 801px) {
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  ${p => p.theme.phone} {
    min-width: 100%;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      min-width: 100%;
    `}
`

export const PriceGroupItemPlanTitleUi = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: #181c39;
  margin-right: 10px;

  @media only screen and (min-width: 801px) {
    display: none;
  }
`
